// extracted by mini-css-extract-plugin
export var actionButton = "_dj-0";
export var attachmentLine = "_dj-1";
export var fileInput = "_dj-2";
export var fileUploadWrapper = "_dj-4";
export var footer = "_dj-3";
export var modalContent = "_dj-5";
export var paperclip = "_dj-6";
export var quillEditor = "_dj-7";